import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type ConsumerProblemFragment = { __typename?: 'Problem', id: string, creation_timestamp: string, event_name: string, event_data: string, store_text_id?: string | null, store_name?: string | null };

export const ConsumerProblemFragmentDoc = gql`
    fragment ConsumerProblem on Problem {
  id
  creation_timestamp
  event_name
  event_data
  store_text_id
  store_name
}
    `;